"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseConfig = void 0;
exports.baseConfig = {
    // TODO: this key will expire on September 28th, 2025.
    licenseKey: '86feb-7b29b-570a4-5e64a-8e958',
    functionArgSeparator: ',',
    // decimalSeparator: '.', // set by default
    // thousandSeparator: '', // set by default
    // arrayColumnSeparator: ',', // set by default
    // arrayRowSeparator: ';', // set by default
    // dateFormats: ['MM/DD/YYYY', 'MM/DD/YY', 'YYYY/MM/DD'],
    dateFormats: ['YYYY-MM-DD'],
    timeFormats: ['hh:mm', 'hh:mm:ss.sss'],
    nullYear: 30,
    caseSensitive: false,
    accentSensitive: true,
    ignorePunctuation: false,
    localeLang: 'en',
    useWildcards: true,
    useRegularExpressions: false,
    matchWholeCell: true,
    useArrayArithmetic: true,
    ignoreWhiteSpace: 'any',
    evaluateNullToZero: true,
    leapYear1900: true,
    nullDate: { year: 1899, month: 12, day: 31 },
    // this is by default true for excel
    smartRounding: false,
};
//# sourceMappingURL=config.js.map